import React, { useContext, useState } from "react";

import legajoContext from "../../context/legajoContext/legajoContex";
import LegajosList from "../../components/legajosList/LegajosList";
import SearchInput from "../../components/searchInput/SearchInput";

import Swal from 'sweetalert2'

import './Legajo.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { Navigate, useNavigate } from "react-router-dom";
import AbmLegajos from "../../components/abmLegajos/abmLegajos";
import authContext from "../../context/authentication/authContex";

const Legajo = () =>{

  const lContext = useContext(legajoContext);
  const { usuario, hasWebServiceConfigured } = useContext(authContext);;

  const [filter,setFilter] = useState('');
  const [showAbm, setShowAbm] = useState(false);
  const {legajosList, actualizarLegajosList, actualizarLegajosFromSoftland} = lContext
  const [legajoToEdit, setLegajoToEdit] = useState({});
  const navigate = useNavigate();

  const handleGetLegajosFromSoftland = async() => {
    if(hasWebServiceConfigured){
      Swal.fire({
        title: 'Desea actualizar la lista?',
        html: `Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.<br><label style="font-weight:500">SE RECOMIENDA ACTUALIZAR PREVIAMENTE EL ABM DE CATEGORIAS!</label>`,
        showCancelButton: true,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'No, cancelar',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            return await actualizarLegajosFromSoftland()
            .then(response => {
              if (!response.status) {
                throw new Error(response.msg)
              }
              return response;
            })
            .catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error}`
              )
            })
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire(
                'Actualizado!',
                'La base de datos ha sido actualizada correctamente.',
                'success'
            );
            //actualizarLegajosList();
        }
      })
    }else{
      Swal.fire({
        title:"No es posible actualizar los Legajos!", 
        text:"No se ha configurado una conexión con un sistema externo, utilice el botón + en azul para dar de alta los legajos en forma manual o mediante una planilla xlsx. Si desea configurar un sistema externo comuníquese con el soporte de XertuX",
        confirmButtonColor:'#3d4d87',
      });
    }
  }

  const handleEditLegajo = (legajo) =>{
    setLegajoToEdit(legajo);
    setShowAbm(true);
  }

  return <div className="legajoDiv">
      <button style={{cursor:'pointer'}} onClick={()=>navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
      <SearchInput filter={filter} buscar={setFilter}/>
      <button className="agregar-productos-btn" onClick={()=>setShowAbm(true)}> + </button>
      <button className="getLegajosFromSoftlandBtn" onClick={handleGetLegajosFromSoftland}>Actualizar Legajos</button>
      {(legajosList == undefined) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (legajosList.length == 0) ? <h3 className="warningStatusMsg">No hay legajos cargados</h3> : <LegajosList legajosList={legajosList} filter={filter} handleEditLegajo={handleEditLegajo}/>}
      {showAbm && <AbmLegajos setShowAbm={setShowAbm} legajoToEdit={legajoToEdit} setLegajoToEdit={setLegajoToEdit}/>}
  </div>
}

export default Legajo;